export default "__VITE_ASSET__62f68208__"